import {getConfig} from "../../utils/config"
const config = getConfig()

const BASE_URL = config.api.baseUrl

const API_VERSION = 'v1'
const API_ROOT = `${BASE_URL}/api/${API_VERSION}`

export default {
    auth: {
        getToken: `${BASE_URL}/api/token/`,
        refreshToken: `${BASE_URL}/api/token/refresh/`,
        resetPasswordToken: `${API_ROOT}/users/generate-token-to-reset-password/`,
        validatePasswordToken: `${API_ROOT}/users/validate-user-token/`,
    },
    users: {
        search: `${API_ROOT}/users/search/`,
        register: `${API_ROOT}/users/`,
        find: `${API_ROOT}/users/`,
        login: '',
        getAccountantInfo: `${API_ROOT}/users/get-accountant-info/`,
        createInviteCode: `${API_ROOT}/users/create-invite-code/`,
        myIndications: `${API_ROOT}/users/my-indications/`
    },
    certificates: `${API_ROOT}/certificates/`,
    branches: `${API_ROOT}/branches/`,
    branchSettings: `${API_ROOT}/branch-config/`,
    config: `${API_ROOT}/config/`,
    products: {
        products: `${API_ROOT}/products/`,
        units: `${API_ROOT}/products/units/`,
        categories: `${API_ROOT}/products/categories/`,
        ncm: `${API_ROOT}/products/ncm/`,
        cest: `${API_ROOT}/products/cest/`,
        cfop: `${API_ROOT}/products/cfop/`,
        maxCode: `${API_ROOT}/products/max-code/`
    },
    till: {
        history: `${API_ROOT}/tills/`,
        today: `${API_ROOT}/tills/today/`
    },
    nfe: `${API_ROOT}/nfe/`,
    nfeTransporter: `${API_ROOT}/nfe-transporter/`,
    nfeHistory: `${API_ROOT}/nfe/history/`,
    nfse: {
        nfse: `${API_ROOT}/nfse/`,
        config: `${API_ROOT}/nfse-config/`,
        aiReadService: `${API_ROOT}/nfse/ai-read-service/`
    },
    plans: `${API_ROOT}/plans/`,
    branchPlans: `${API_ROOT}/branch-plans/`,
    branchPlanUpdate: `${API_ROOT}/branch-plans/upgrade/`,
    planResume: `${API_ROOT}/branch-plans/details/`,
    defaultData: {
        cnae: `${API_ROOT}/cnaes/`,
    },
    clients: `${API_ROOT}/clients/`,
    icms: `${API_ROOT}/icms/`,
    ipi: `${API_ROOT}/ipi/`,
    pis: `${API_ROOT}/pis/`,
    suppliers: `${API_ROOT}/suppliers/`,
    sales: `${API_ROOT}/sales/`,
    sale: {
        createSale: `${API_ROOT}/sales/`,
        paymentMethods: `${API_ROOT}/payment-methods/`,
    },
    salesperson: `${API_ROOT}/salespersons/`,
    states: `${API_ROOT}/state-location/`,
    cities: `${API_ROOT}/city-location/`,
    searchBarcode: `${API_ROOT}/products/search_barcode/`,
    searchCmpanyByCnpj: `${API_ROOT}/checkcompany/?cnpj`,

    statistics: {
        saleProduct: `${API_ROOT}/sales-reports/sale-product/`
    },
    reports: {
        bestSellers: `${API_ROOT}/sales/best-sellers/`,
        requestPermissions: `${API_ROOT}/request-permission/`,
    },
    stock: {
        history: `${API_ROOT}/products/stock-history/`,
        stocks: `${API_ROOT}/products/stocks/`,
        stockInfo: `${API_ROOT}/products/stock-info/`,
    },
    nfce: `${API_ROOT}/nfce/`,
    invoices: {
        branchInvoices: `${API_ROOT}/invoices/`,
        cancelSubscribe: `${API_ROOT}/invoices/cancel-subscription/`
    },
    feedbacks: {
        cancelBranchPlan: `${API_ROOT}/feedbacks/cancel-plan/`
    },
    baseUrl: BASE_URL,
    store: {
        certificates: `${API_ROOT}/my-indications/store/certificates/checkout/`
    }

}



// WEBPACK FOOTER //
// ./src/sources/api/index.js